import {Component, OnInit, Input} from '@angular/core';
import {ILineV2} from '@app/shared/interfaces/iline-v2.interface';
import {SearchCriteria, WindowRefService} from '@app/core';

@Component({
    selector: 'app-occupation',
    templateUrl: './occupation.component.html',
    styleUrls: ['./occupation.component.scss']
})
export class OccupationComponent implements OnInit {

    @Input() model: {
        adults: number,
        child: number,
        occupation: string,
    };
    adultsArray: Array<number> = [];
    childsArray: Array<number> = [];
    occupationSearch: string;
    searchCriteria: SearchCriteria

    constructor(private winRef: WindowRefService) {}

    ngOnInit() {
        const searchCriteria: SearchCriteria = {
            adults: this.winRef.appConfigSite.adults,
            children: this.winRef.appConfigSite.enfants
        };
        this.searchCriteria = searchCriteria;
        this.adultsArray = Array.from(Array(this.model.adults).keys());
        this.childsArray = Array.from(Array(this.model.child).keys());
        this.occupationSearch = ''.concat(this.searchCriteria.adults.toString(), '_', this.searchCriteria.children.toString());
    }

    get occupationMoins(): boolean {
        let occupations = this.model.occupation.split('_'),
            occupationsSearch = this.occupationSearch.split('_'),
            adults = occupations[0], enfants = occupations[1],
            adultsSearch = occupationsSearch[0], enfantsSearch = occupationsSearch[1],
            isAdultsMoins = parseInt(adults) < this.searchCriteria.adults
            ;
        return isAdultsMoins || ((parseInt(adults) + parseInt(enfants)) < (parseInt(adultsSearch) + parseInt(enfantsSearch))); // un enfant peut prend la palce d'un adult mais un adult ne peut pas prend la place d'un enfant
    }

}
